import * as React from "react";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";

export function useCanRenderAdvanced() {
  const ownership = useCpFormValue("meta.dryRun.ownership");
  const name = useCpFormValue("advanced.name");

  const checkedOwnership = ownership.checkedName === name;

  if (!name || !checkedOwnership || (checkedOwnership && !ownership.passed)) {
    return false;
  }
  return true;
}
